// extracted by mini-css-extract-plugin
export var author = "QuoteCard-module--author--22331";
export var authorInfo = "QuoteCard-module--authorInfo--956c1";
export var authorName = "QuoteCard-module--authorName--8f6bd";
export var hr = "QuoteCard-module--hr--a6732";
export var link = "QuoteCard-module--link--37c24";
export var logo = "QuoteCard-module--logo--fd609";
export var logoWrapper = "QuoteCard-module--logoWrapper--1c87e";
export var quoteMark = "QuoteCard-module--quoteMark--f039a";
export var quoteMarkMobile = "QuoteCard-module--quoteMarkMobile--384f5";
export var root = "QuoteCard-module--root--697aa";
export var text = "QuoteCard-module--text--59df0";
export var textWrapper = "QuoteCard-module--textWrapper--e3873";
export var wrapper = "QuoteCard-module--wrapper--a5152";